export const changeBlogCategory = (newCategory) => {
  return {
    type: 'CHANGE_BLOG_CATEGORY',
    payload: newCategory,
  };
};

export const resetBlogCategory = () => {
  return { type: 'RESET_BLOG_CATEGORY' };
};
